<script setup>
import {ref, reactive, onBeforeMount, watch, nextTick} from "vue";
import {getAddressListHook} from "@/hooks/address.js";
import {addressStore} from "@/store/store.js";

const props = defineProps({
  // 是否返回字符串类型的省市区信息
  isReturnStr: {
    type: Boolean,
    default: false
  },
  // 父组件address字符串
  address: {
    type: [String, Array],
  },
  // 父组件address Code值
  addressCode: {
    type: [String, Array],
  },
  // 占位符标题
  title: {
    type: String,
    default: "所属区域"
  },
  // 只显示两级城市
  onlySecond: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['select', 'blur'])
/*已选择的省市区信息*/
const code = ref([])
/*省市区信息缓存*/
const options = ref()
const loading = ref(false)
onBeforeMount(async () => {
  // 获取省市区信息
  if (!addressStore().address) {
    console.log("正在获取省市区信息")
    loading.value = true
    await getAddressListHook()
    loading.value = false
  }
  // 获取省市区信息缓存，可以自定义只返回二级
  console.log("onlySecond", props.onlySecond)
  // 深拷贝，若有只显示二级城市则不影响到缓存
  options.value = JSON.parse(JSON.stringify(addressStore().address))
  if (props.onlySecond) {
    options.value = options.value.filter((province) => {
      province.children.forEach((city) => {
        city.children = []
      })
      return province
    })
  }
  // 防止watch反显失效，兜底
  if (props.addressCode) await handleValue2Code()
})

watch(
    () => props.addressCode,
    (newVal, oldVal) => {
      // 处理反显
      if (newVal !== oldVal) handleValue2Code()
    }
)

/*
* @Name 内容修改
* @Author XNHOTARU
* @Return String/Array value 省市区编码数组/字符串
* @Return String/Array label 省市区名称数组/字符串
* */
const handleChange = async () => {
  const cityVal = await handleCode2Value(code.value)
  const param = reactive({
    value: props.isReturnStr ? code.value.join("/") : [...code.value],
    label: props.isReturnStr ? cityVal.join("/") : cityVal
  })
  emit("select", param)
}
/*处理省市区编码转换字符串*/
const handleCode2Value = async () => {
  let cityVal = []
  await options.value.map(first => {
    if (first.value === code.value[0]) {
      cityVal[0] ? cityVal[0] = first.label : cityVal.push(first.label)
      if (first.children.length > 0) {
        first.children.map(second => {
          if (second.value === code.value[1]) {
            cityVal[1] ? cityVal[1] = second.label : cityVal.push(second.label)
            if (second.children.length > 0) {
              second.children.map(third => {
                if (third.value === code.value[2]) {
                  cityVal[2] ? cityVal[2] = third.label : cityVal.push(third.label)
                }
              })
            }
          }
        })
      }
    }
  })
  return cityVal
}

/*处理字符串/数组转换省市区编码*/
const handleValue2Code = async () => {
  console.log("run in handleValue2Code")
  let target = []
  if (props.isReturnStr) {
    target = props.addressCode.split("/")
  } else {
    target = props.addressCode
  }
  console.log("target", target)
  if (!target) return console.log("无数据不进行遍历")
  await nextTick(async () => {
    await options.value.map(first => {
      if (first.value === target[0]) {
        code.value.push(first.value)
        if (first.children.length > 0) {
          first.children.map(second => {
            if (second.value === target[1]) {
              code.value.push(second.value)
              if (second.children.length > 0) {
                second.children.map(third => {
                  if (third.value === target[2]) {
                    code.value.push(third.value)
                  }
                })
              }
            }
          })
        }
      }
    })
  })
}

const cleanSelect = () => {
  code.value = null
}

defineExpose({
  cleanSelect
})

</script>

<template>
  <div v-loading="loading">
    <el-cascader style="width: 100%" v-model="code" :options="options" @change="handleChange" :placeholder="`请选择${props.title}`"/>
  </div>
</template>

<style scoped>

</style>
